module.exports = __webpack_public_path__ + "static/media/edit-button.dd247806.svg";